export default function weightedPickone(list, random, exponent = 2) {
  return list[
    Math.floor(
      Math.pow(random.floating({ min: 0, max: 0.99 }), exponent) * list.length
    )
  ];
}
